<div class="menu-search">
  <div
    class="inpsearch"
    matAutocompleteOrigin
    #searchOrigin="matAutocompleteOrigin"
    [class.mobile]="(screenSize$ | async)?.isMobile"
    [class.panel-open]="panelOpen"
  >
    <mat-icon class="iconsearch srcicon">search</mat-icon>
    <mat-form-field floatLabel="never">
      <mat-label>{{ label }}</mat-label>
      <input
        matInput
        #inputAutoComplete
        type="text"
        [formControl]="mysearch"
        [matAutocomplete]="menuSearch"
        [matAutocompleteConnectedTo]="searchOrigin"
        (focus)="onFocus()"
        (input)="lastTypedSearch = inputAutoComplete.value"
        name="topSearchInput"
        class="pendo-nav-search-input"
        autocomplete="off"
      />
      <div class="iresult" *ngIf="!loading && mystart">
        {{ (items$ | async)?.entity_prefix_search?.hits?.length }} results
      </div>
      <mat-autocomplete
        #menuSearch="matAutocomplete"
        (optionSelected)="goSelect($event.option.value)"
        (opened)="panelOpen = true"
        (closed)="panelOpen = false"
        [autoActiveFirstOption]="!emptyInput"
        class="filterSearch search-panel"
      >
        <mat-optgroup
          class="nav-search-group nav-search-group--action"
          *ngIf="
            !hasSearchResults &&
            !(screenSize$ | async)?.isMobile &&
            !routing.isIframe()
          "
        >
          <mat-option
            [value]="'aiSearch'"
            id="ai-search"
            class="pendo-ai-search-option"
          >
            <div class="ai-search-option">
              <mat-icon>auto_awesome</mat-icon>
              <div class="ai-search-option-text">
                <div class="ai-search-label">
                  <span>AI Automated Search</span>
                  <span class="beta-badge">BETA</span>
                </div>
                <span class="ai-search-subtitle"
                  >Find the closest match using AI</span
                >
              </div>
            </div>
          </mat-option>
        </mat-optgroup>
        <div
          *ngIf="
            (!emptyInput ||
              (screenSize$ | async)?.isMobile ||
              routing.isIframe()) &&
              items$ | async as search
          "
        >
          <div
            *ngFor="
              let items of search['entity_prefix_search']?.hits
                | groupBy: 'entity.type'
                | orderByType
                | pairs;
              let i = index
            "
          >
            <mat-optgroup
              *ngIf="
                items[0] !== 'product' &&
                items[0] !== 'product_model' &&
                items[0] !== 'topic'
              "
            >
              <div class="optgroup-search">
                <div class="indexo-left">{{ items[0] | nicetxt }}</div>
                <div class="indexo-right">
                  <div class="optgroup-column column-0"></div>
                  <div class="optgroup-column column-1">Country</div>
                  <div class="optgroup-column"># Articles</div>
                </div>
              </div>
              <ng-container
                *ngFor="
                  let option of items[1]
                    | slice: 0 : (checkShowMoreEntities(i) ? 1000 : 5)
                "
              >
                <mat-option *ngIf="!option.entity.hasParent" [value]="option">
                  <div class="search-indexo">
                    <div class="indexo-left">
                      <span>{{ option.entity.name }}</span>
                    </div>
                    <div class="indexo-right">
                      <div class="optgroup-column column-0">
                        <div
                          class="alert-container"
                          *ngIf="option.entity.is_sanctioned"
                        >
                          <mat-icon
                            svgIcon="alert"
                            matTooltip="Sanctioned Entity. See Entity Page for Details."
                            [class.theme-light]="theme === 'light'"
                          ></mat-icon>
                          <span class="match">{{
                            option.entity.matched_form
                              ? option.entity.matched_form
                              : ''
                          }}</span>
                        </div>
                      </div>
                      <div class="optgroup-column column-1">
                        {{
                          option.entity &&
                          option.entity.country &&
                          option.entity.country.alpha_id
                            ? option.entity.country.alpha_id.toUpperCase()
                            : '\u2014'
                        }}
                      </div>
                      <div class="optgroup-column">
                        {{
                          option.count || option.count === 0
                            ? numberFormat(option.count)
                            : ''
                        }}
                      </div>
                    </div>
                  </div>
                </mat-option>
                <mat-option
                  *ngFor="
                    let optionChild of option.entity.children
                      | slice: 0 : (checkShowMoreEntities(i) ? 1000 : 5)
                  "
                  [value]="optionChild"
                >
                  <div class="search-indexo">
                    <div class="indexo-left">
                      <span class="subsidiary">{{
                        optionChild.entity.name
                      }}</span>
                    </div>
                    <div class="indexo-right">
                      <div class="optgroup-column column-0">
                        <div
                          class="alert-container"
                          *ngIf="optionChild.entity.is_sanctioned"
                        >
                          <mat-icon
                            svgIcon="alert"
                            matTooltip="Sanctioned Entity. See Entity Page for Details."
                            [class.theme-light]="theme === 'light'"
                          ></mat-icon>
                          <span class="match">{{
                            optionChild.entity.matched_form
                              ? optionChild.entity.matched_form
                              : ''
                          }}</span>
                        </div>
                      </div>
                      <div class="optgroup-column column-1">
                        {{
                          optionChild.entity &&
                          optionChild.entity.country &&
                          optionChild.entity.country.alpha_id
                            ? optionChild.entity.country.alpha_id.toUpperCase()
                            : '\u2014'
                        }}
                      </div>
                      <div class="optgroup-column">
                        {{
                          optionChild.count || optionChild.count === 0
                            ? numberFormat(optionChild.count)
                            : ''
                        }}
                      </div>
                    </div>
                  </div>
                </mat-option>
              </ng-container>
              <mat-option
                class="expand-search-results"
                [disabled]="true"
                *ngIf="items[1] && items[1].length > 5"
              >
                <mat-icon
                  *ngIf="!checkShowMoreEntities(i)"
                  (click)="$event.stopPropagation(); expandEntitiesGroup(i)"
                  >arrow_drop_down</mat-icon
                >
                <span
                  *ngIf="!checkShowMoreEntities(i)"
                  (click)="$event.stopPropagation(); expandEntitiesGroup(i)"
                  >Show more
                  {{ (items[0] | nicetxt: true).toLowerCase() }}</span
                >
                <mat-icon
                  *ngIf="checkShowMoreEntities(i)"
                  (click)="$event.stopPropagation(); expandEntitiesGroup(i)"
                  >arrow_drop_up</mat-icon
                >
                <span
                  *ngIf="checkShowMoreEntities(i)"
                  (click)="$event.stopPropagation(); expandEntitiesGroup(i)"
                  >Show less
                  {{ (items[0] | nicetxt: true).toLowerCase() }}</span
                >
              </mat-option>
            </mat-optgroup>
          </div>
          <mat-optgroup *ngIf="!loadingPNE && itemsPNE.length">
            <div class="optgroup-search">
              <div class="indexo-left">Other Potential Entity</div>
              <div class="indexo-right"></div>
            </div>
            <mat-option
              *ngFor="let option of itemsPNE | slice: 0 : checkShowMorePNEs()"
              [value]="{ type: 'pne', pne: option }"
            >
              <div class="search-indexo">
                <div class="indexo-left">
                  <span>{{ option.surface }}</span>
                  <span class="match">{{
                    option.type ? option.type : ''
                  }}</span>
                </div>
                <div class="indexo-right">
                  <div class="optgroup-column column-0"></div>
                  <div class="optgroup-column column-1"></div>
                  <div class="optgroup-column">
                    {{
                      option.count || option.count === 0
                        ? numberFormat(option.count)
                        : ''
                    }}
                  </div>
                </div>
              </div>
            </mat-option>
            <mat-option
              class="expand-search-results"
              [disabled]="true"
              *ngIf="itemsPNE && itemsPNE.length > 5"
            >
              <mat-icon
                *ngIf="!showMorePNEs"
                (click)="$event.stopPropagation(); expandPNEsGroup()"
                >arrow_drop_down</mat-icon
              >
              <span
                *ngIf="!showMorePNEs"
                (click)="$event.stopPropagation(); expandPNEsGroup()"
                >Show more potential entities</span
              >
              <mat-icon
                *ngIf="showMorePNEs"
                (click)="$event.stopPropagation(); expandPNEsGroup()"
                >arrow_drop_up</mat-icon
              >
              <span
                *ngIf="showMorePNEs"
                (click)="$event.stopPropagation(); expandPNEsGroup()"
                >Show less potential entities</span
              >
            </mat-option>
          </mat-optgroup>
          <mat-optgroup *ngIf="loadingPNE">
            <div class="optgroup-search">
              <div class="indexo-left">Other Potential Entity</div>
              <div class="indexo-right" style="justify-content: end">
                <mat-spinner [diameter]="15"></mat-spinner>
              </div>
            </div>
          </mat-optgroup>
        </div>
        <mat-optgroup
          class="nav-search-group"
          label="Recent"
          *ngIf="emptyInput"
        >
          <mat-option
            *ngFor="let entry of aiRecents"
            [value]="{ type: 'aiRecent', recent: entry }"
          >
            <div class="search-indexo">
              <div class="indexo-left">
                <mat-icon class="recent-ai-icon">auto_awesome</mat-icon>
                <span>{{ entry.data.name }}</span>
              </div>
              <div class="indexo-right"></div>
            </div>
          </mat-option>
          <mat-option *ngFor="let option of previousSearches" [value]="option">
            <div class="search-indexo">
              <div class="indexo-left">
                <span>{{ option.entity ? option.entity.name : '' }}</span>
              </div>
              <div class="indexo-right">
                <span class="recent-kind">{{
                  option.entity ? (option.entity.type | nicetxt) : ''
                }}</span>
              </div>
            </div>
          </mat-option>
        </mat-optgroup>
        <mat-optgroup
          class="nav-search-group nav-search-group--action"
          *ngIf="
            hasSearchResults &&
            !(screenSize$ | async)?.isMobile &&
            !routing.isIframe()
          "
        >
          <mat-option
            [value]="'aiSearch'"
            id="ai-search"
            class="pendo-ai-search-option"
          >
            <div class="ai-search-option">
              <mat-icon>auto_awesome</mat-icon>
              <div class="ai-search-option-text">
                <div class="ai-search-label">
                  <span>AI Automated Search</span>
                  <span class="beta-badge">BETA</span>
                </div>
                <span class="ai-search-subtitle"
                  >Find the closest match using AI</span
                >
              </div>
            </div>
          </mat-option>
        </mat-optgroup>
      </mat-autocomplete>
      <mat-spinner [diameter]="15" *ngIf="loading"></mat-spinner>
    </mat-form-field>
    <span
      class="search-shortcut"
      *ngIf="!(screenSize$ | async)?.isMobile"
      aria-hidden="true"
      >{{ shortcutLabel }}</span
    >
  </div>
</div>
